export const BRAND_DOMAINS = {
  "789BK": "789BK.NET",
  BIG188: "BIG188.COM",
  CY268: "CY268.COM",
  DEE99: "DEE99.GG",
  DM961: "DM961.COM",
  DMBL1: "DMBL1.COM",
  DMKZ1: "DMKZ1.COM",
  DMKZ2: "DMKZ2.COM",
  DMWD1: "DMWD1.COM",
  EZWIN: "EZWIN.NET",
  GO989: "GO989.GG",
  GOGO69: "GOGO69.COM",
  HK39: "HK39.COM",
  JAI88: "JAI88.NET",
  KBK99: "KBK99.GG",
  KISS39: "KISS39.COM",
  KK69: "KK69.COM",
  MK69: "MK69.NET",
  MOO555: "MOO555.GG",
  OK69: "OK69.COM",
  POP369: "POP369.COM",
  POPWIN: "POPWIN.NET",
  RM99: "RM99.GG",
  RNG999: "RNG999.COM",
  SOS69: "SOS69.COM",
  SUK555: "SUK555.NET",
  TPH1: "TPH1.DEV",
  TTH1: "TTH1.DEV",
  TTH2: "TTH2.DEV",
  TPG1: "TPG1.DEV",
  TPG2: "TPG2.DEV",
  TRU99: "TRU99.COM",
  W268: "W268.COM",
  WOW69: "WOW69.COM",
  XC69: "XC69.COM",
  XO268: "XO268.GG",
  YES69: "YES69.COM",
} as const;
